import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import PerformanceDashboard from './PerformanceDashboard';

const PerformanceRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path="/performance" exact={true} component={PerformanceDashboard} />
      <Redirect from="/performance/*" to="/performance" />
    </Switch>
  );
};

export default PerformanceRoutes;
